import React, { useState, useEffect } from "react";
import { Calendar } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../../Styles/DaList.css";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { getExpendituresApi } from "../../Services/Operations/ProductAPI";

const formatDate = (date) => {
  return date.toLocaleDateString("en-CA");
};

const formatApiDate = (apiDateStr) => {
  const dateObj = new Date(apiDateStr);
  return dateObj.toLocaleDateString("en-CA");
};


export default function DAList() {
  const [expenditures, setExpenditures] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    const fetchExpendituresList = async () => {
      try {
        const response = await getExpendituresApi(token);
        console.log("Expenditures:", response);
        setExpenditures(response || []);
      } catch (error) {
        console.error("Error fetching expenditures:", error);
      }
    };

    fetchExpendituresList();
  }, [token]);

  const selectedKey = formatDate(selectedDate);

  // Filter expenditures by selected date
  const filteredExpenditures = expenditures.filter(
    (e) => formatApiDate(e.expenditureDate) === selectedKey
  );

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="container">
          <h1 className="title">Employee DA Tracker</h1>

          <div className="calendar-wrapper" >
            <Calendar
              onChange={setSelectedDate}
              value={selectedDate}
              className="custom-calendar"
            style={{backgroundColor:"black"}}
            />
          </div>

          <div className="expenditure-section">
            <h2 className="subheading">DA on {selectedKey}:</h2>

            {filteredExpenditures.length === 0 ? (
              <p className="no-data">No DA recorded.</p>
            ) : (
              <div className="expenditure-list">
                {filteredExpenditures.map((e, idx) => (
                  <div key={idx} className="expenditure-card">
                    <div className="card-top">
                      <h3 className="topic">{e.expenditureTopic}</h3>
                      <div className="amount">₹{e.expenditureAmount.toFixed(2)}</div>
                    </div>
                    <div className="card-bottom">
                      <p><strong>Employee:</strong> {e.employeeName || "Unknown"}</p>
                      <p><strong>Sub Total:</strong> ₹{e.subTotal.toFixed(2)}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
